import { useMemo } from 'react';

// ISO week-of-year (UTC) helper
const getISOWeekYear = (date: Date) => {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));

  // ISO day: Mon=1..Sun=7
  const day = d.getUTCDay() || 7;

  // Shift to Thursday to determine ISO year
  d.setUTCDate(d.getUTCDate() + 4 - day);

  const isoYear = d.getUTCFullYear();
  const yearStart = new Date(Date.UTC(isoYear, 0, 1));

  const weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);

  return { isoYear, isoWeek: weekNo };
};

const getISOWeeksInYear = (isoYear: number) => {
  // ISO years have 52 or 53 weeks. Week number of Dec 28 always tells you.
  const { isoWeek } = getISOWeekYear(new Date(Date.UTC(isoYear, 11, 28)));
  return isoWeek; // 52 or 53
};

export const useWeeks = () => {
  return useMemo(() => {
    const { isoYear, isoWeek } = getISOWeekYear(new Date());
    const weeksInYear = getISOWeeksInYear(isoYear);

    const weeksArray = Array.from({ length: weeksInYear }, (_, i) => ({
      label: `Week ${i + 1}`,
      weekNumber: i + 1, // 1..52/53
      index: i, // 0..51/52
    }));

    // Default selection = current week (index = isoWeek-1)
    const latestIndex = Math.max(0, isoWeek - 1);

    return { weeks: weeksArray, latestWeekOffset: latestIndex, currentISOWeek: isoWeek };
  }, []);
};
